(function () {
  function parsePrice(str) {
    if (!str) return 0;
    return parseFloat(str.replace(/[^0-9,\.]/g, '').replace(',', '.')) || 0;
  }

  function applyBadges() {
    var cards = document.querySelectorAll(
      '.product-card, [class*="product-card"], .card-wrapper, [class*="card-wrapper"], li[class*="grid__item"], .collection-grid__item'
    );

    // Phase de lecture : on calcule tout sans écrire dans le DOM. Les getComputedStyle
    // sont groupés ici pour éviter les recalculs de mise en page forcés (layout thrashing).
    var plans = [];
    cards.forEach(function (card) {
      var promoBadges = [];
      var existingBadges = card.querySelectorAll('.badge, [class*="badge"], [class*="tag"]');
      existingBadges.forEach(function (b) {
        var txt = b.textContent.trim().toLowerCase();
        if (txt === 'promotion' || txt === 'sale' || txt === 'soldes' || txt === 'promo') {
          promoBadges.push(b);
        }
      });

      var plan = { card: card, promoBadges: promoBadges, draw: false };

      var compareEl = card.querySelector('s, del, [class*="compare"], [class*="regular"] s, [class*="regular"] del');
      var allPriceEls = card.querySelectorAll('[class*="price"]');
      var saleEl = null;
      allPriceEls.forEach(function (el) {
        if (el.tagName !== 'S' && el.tagName !== 'DEL' && el.closest('s') === null && el.closest('del') === null) {
          var txt = el.textContent.replace(/[^0-9,\.€]/g, '');
          if (txt.length > 0 && !saleEl) saleEl = el;
        }
      });

      if (compareEl && saleEl) {
        var comparePrice = parsePrice(compareEl.textContent);
        var salePrice = parsePrice(saleEl.textContent);
        if (comparePrice && salePrice && comparePrice > salePrice) {
          var pct = Math.round((1 - salePrice / comparePrice) * 100);
          if (pct > 0 && pct <= 99) {
            var imgWrapper = card.querySelector('[class*="media"], [class*="image"], [class*="gallery"], figure, .card__media') || card;
            var priceContainer = card.querySelector('[class*="price-wrapper"], [class*="price__container"], [class*="price-item"]');
            if (!priceContainer) {
              var allP = card.querySelectorAll('[class*="price"]');
              if (allP.length) priceContainer = allP[allP.length - 1];
            }
            plan.draw = true;
            plan.pct = pct;
            plan.imgWrapper = imgWrapper;
            plan.needRelative = window.getComputedStyle(imgWrapper).position === 'static';
            plan.priceContainer = priceContainer;
            plan.savingsParent = priceContainer
              ? (priceContainer.closest('[class*="card-information"], [class*="product-card__info"], [class*="card__content"]') || priceContainer.parentElement)
              : null;
          }
        }
      }

      plans.push(plan);
    });

    // Phase d'écriture : mutations DOM groupées (aucune lecture de layout ici → pas de reflow forcé).
    // On retire d'abord TOUT badge/label déjà injecté dans la carte, pour rester idempotent même si
    // plusieurs sélecteurs matchent la même carte ou si la fonction est rappelée.
    plans.forEach(function (p) {
      p.promoBadges.forEach(function (b) { b.style.display = 'none'; });

      var injected = p.card.querySelectorAll('.ch-pct-badge, .ch-savings-label');
      for (var k = 0; k < injected.length; k++) injected[k].remove();

      if (!p.draw) return;

      if (p.needRelative) p.imgWrapper.style.position = 'relative';

      var badge = document.createElement('div');
      badge.className = 'ch-pct-badge';
      badge.textContent = '-' + p.pct + '%';
      p.imgWrapper.appendChild(badge);

      if (p.priceContainer) {
        var savingsEl = document.createElement('span');
        savingsEl.className = 'ch-savings-label';
        savingsEl.textContent = 'Économisez ' + p.pct + '%';
        if (p.savingsParent) {
          p.savingsParent.appendChild(savingsEl);
        } else {
          p.priceContainer.parentElement.insertBefore(savingsEl, p.priceContainer.nextSibling);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyBadges);
  } else {
    applyBadges();
  }
  setTimeout(applyBadges, 800);
  setTimeout(applyBadges, 2000);
})();
